import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "CookiesMainView"
}
const _hoisted_2 = { class: "BigPlaceholder P-Rel" }
const _hoisted_3 = { class: "BigContainer" }
const _hoisted_4 = { class: "BigHeader O-754" }
const _hoisted_5 = {
  class: "D-Flex HeaderFlex",
  style: {"gap":"1em"}
}
const _hoisted_6 = {
  key: 0,
  class: "D-Flex HeaderFilterIconDiv"
}
const _hoisted_7 = { class: "F-Bold F1_75em BigHeaderText" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesColSplitter MobileHider" }, null, -1)
const _hoisted_9 = { class: "HeaderButtons M-Auto" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "M-Auto" }, null, -1)
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "BigBody P-Rel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesFilterPannel = _resolveComponent("CookiesFilterPannel")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesTabs = _resolveComponent("CookiesTabs")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.Access('Finance_View'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.$route.name && _ctx.Filters[_ctx.$route.name])
            ? (_openBlock(), _createBlock(_component_CookiesFilterPannel, {
                key: 0,
                onCloseMe: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ShowFilter = false)),
                FilterSettings: _ctx.$route.name && _ctx.Filters[_ctx.$route.name],
                ShowFilter: _ctx.ShowFilter
              }, null, 8, ["FilterSettings", "ShowFilter"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.$route.name && _ctx.Filters[_ctx.$route.name])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_CookiesIcon, {
                        ToolTip: _ctx.Translate('Filter'),
                        class: "FilterButton HoverUp",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ShowFilter = true)),
                        style: {"width":"2.2em","height":"2.2em","margin":"auto 0.5em","padding":"0em 1em"},
                        ID: 'Filter'
                      }, null, 8, ["ToolTip"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.Translate('Finance')), 1),
                _createVNode(_component_CookiesTabs, {
                  Router: true,
                  class: "M-Auto HeaderTabs",
                  Default: _ctx.Tabs[1],
                  Tabs: _ctx.Tabs
                }, null, 8, ["Default", "Tabs"]),
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.Access('Finance_Invoices_Create') && _ctx.$route.name !== 'Accounts')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.NewInvoice())),
                        class: "DialogHeaderButton BGMain F1_25em CookiesFade"
                      }, "+ " + _toDisplayString(_ctx.Translate('New Invoice')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_10,
              _createElementVNode("div", {
                class: "D-Flex CookiesSearchInputContainer",
                style: _normalizeStyle(_ctx.$store.getters.Direction === 'ltr' ? 'margin-right: 0em;': 'margin-left: 0em;')
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Search) = $event)),
                  class: "CookiesSearchInput color2 F1_25em",
                  placeholder: _ctx.Translate('Search...')
                }, null, 8, _hoisted_11), [
                  [_vModelText, _ctx.Search]
                ])
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_router_view, {
                Search: _ctx.Search,
                Filter: _ctx.$route.name && _ctx.Filters[_ctx.$route.name]
              }, null, 8, ["Search", "Filter"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}